export default __webpack_public_path__ + "static/media/backcard_superdrug.d0b11b48.png";